import { Component, Input } from '@angular/core';
import { Insurance } from '@core/constants/data-types.constants';

@Component({
  selector: 'mfp-financial-health-protection-card',
  templateUrl: './financial-health-protection-card.component.html',
  styleUrls: ['./financial-health-protection-card.component.scss']
})
export class FinancialHealthProtectionCardComponent {
  @Input() title = '';
  @Input() insurance: Insurance | '' = '';
  @Input() value = 0;
  @Input() description = '';

  constructor() { }

}
